import React, { Fragment, useEffect, useState } from "react";
import "./index.css";
import Stepper from "react-stepper-horizontal";
import Tasks from "./Tasks";
import { useDispatch, useSelector } from "react-redux";
import { createApplicationActivity, getPatientPendingTasks, getPatientTrackedApplication, updateTask } from "../../api/Applications";
import { decryptPatientData } from "../../utils/common";
import { failed, success } from "../../utils/Tostify";
import moment from "moment";
import { calculateAge } from "../../utils/DateSupport";
import { useNavigate } from "react-router";
import { handleFileUpload } from "../../utils/ImageToBase64";
import Loader from "../../components/Loader/Loader";
import PdfViewer from "../../components/PdfViewer/PdfViewer";
import AddApplicationDocumentModal from "../applications/Documents/AddDocument";
import { uploadOrUpdateDocument } from "../../api/patient";
import { ActivityDetails } from "../../utils/constants";

const PatientActivity = () => {
  let token = useSelector((state) => state.userReducer.token);
  let user = useSelector((state) => state.userReducer.user);
  const [openTaskForm, setOpenTaskForm] = useState(false);
  const [trackedApplication, setTrackedApplication] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pdfUrl, setPdfUrl] = useState("");
  const [formData, setFormData] = useState({});
  const [showPdfViewModal, setShowPdfViewModal] = useState(false);
  const [showDocModal, setShowAddDocModal] = useState(false);
  const [applicationId, setapplicationId] = useState("");
  const [taskId, setTaskId] = useState("");
  const patientTrackedApplications = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatientTrackedApplication({dispatch, token, patientId : user?._id});
      if (res?.status === "SUCCESS") {
          await Promise.all(
          res?.data?.map(async (patient) => {
            patient.patientData = patient?.patientId;
            patient.patientId = await decryptPatientData(patient?.patientId);
          })
        );
        setTrackedApplication(res.data);
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const PendingTasks = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatientPendingTasks({dispatch, token, patientId: user?._id});
      if (res?.status === "SUCCESS") {
        const allTasks = res.data.flatMap(item => item.tasks);
          await Promise.all(
            allTasks?.map(async (patient) => {
              if(patient.patientId){
                patient.patientId = await decryptPatientData(patient?.patientId);
              }
               // Find the application that contains the formId
              const application = res.data.find(application => application?._id == patient?.applicationId);
              if (application) {
                // Find the form in the applicationForms array that matches the formId
                const applicationForm = application.applicationForms.find(form => form._id === patient.formId);
                if (applicationForm) {
                  // Add the signUrl from the applicationForm to the task
                  patient.signedUrl = applicationForm?.formFile?.signedUrl;
                }
              }
          })
        );
        const filteredTasks = allTasks.filter(task => task.status !== "Completed");
        setPendingTasks(filteredTasks);
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleDocUpdate = async(file, docId, taskId,task) => {
    let res;
    try {
      let base64pdfForm = "";
          base64pdfForm = await handleFileUpload(file);
          const fileExtension = file?.type?.split("/")[1];
          const docFile = {
              base64String: base64pdfForm,
              extension: fileExtension, // Add the file extension to the object
              name: file?.name
          };
          const payload = {file : docFile};
      setIsLoading(true);
      res = await uploadOrUpdateDocument({ values : payload, dispatch, token, patientId: task.patientId._id, documentId : docId, uploadedBy: user._id ,applicationId: applicationId, type: "task"});
      if (res?.status === "SUCCESS") {
        let values = {
          type : "Application",
          event : ActivityDetails?.DocumentUploadDownload?.event,
          applicationId : task.applicationId,
          clinicId: localStorage.getItem("currentHospitalId"),
          organizationId: localStorage.getItem("currentOrgId"),
          patientId :  task.patientId._id,
          details : "Document Uploaded."
        };
        const payload = {tasks : { status : "Completed"}  };
        await updateTask({values:payload, dispatch, token, applicationId: task.applicationId, taskId});
        await createApplicationActivity({ values, dispatch, token });
        await PendingTasks();
        success(res.message);
        setIsLoading(false);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      // console.log(error);
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleFileSelect = (event,taskId, docId,task, applicationId) => {
    const file = event.target.files[0];
    if (file) {
      (file);
        handleDocUpdate(file, docId, taskId, task, applicationId);
    }
  };


  const triggerFileInputDoc = (appId, taskId, index) => {
    setapplicationId(appId); // Trigger file input
    document.getElementById(`fileInputDoc-${appId}-${taskId}-${index}`)?.click();
    setTaskId(taskId);
  };


  useEffect(() => {
    patientTrackedApplications();
    PendingTasks();
  }, []);


  return (
    <Fragment>
      {isLoading && <Loader/>}
      {showDocModal ? <AddApplicationDocumentModal refetch={()=>{}} status={"Completed"} taskId={taskId} setShowModal={()=> setShowAddDocModal(!showDocModal)} applicationId={applicationId}/> : null}
      {showPdfViewModal ? <PdfViewer url={pdfUrl} refetch={PendingTasks} formData={formData} setShowModal={()=> !setShowPdfViewModal(!showPdfViewModal)}/> : null}
      <div className="activity-container">
        <div className="d-flex gap-4 justify-content-between flex-wrap">
          <div className="tracked_app">
            <div className="d-flex justify-content-between align-items-center tracked_block">
              <h2>Open Application</h2>
            </div>
            <div className="p-4">
              <div className="cards_block">
                {trackedApplication?.length > 0 ? trackedApplication.map((obj) => {
                  const birthDate = obj?.patientId?.birthDate;
                  const formattedBirthDate = birthDate ? moment(birthDate).format("DD-MM-YYYY") : "Unknown Date";
                  const age = formattedBirthDate ? calculateAge(formattedBirthDate) : "Unknown Age";
                  const activeStepIndex =
                    obj?.stages?.some((stage) => stage.status === "NotApproved")
                      ? obj.stages.findIndex((stage) => stage.status === "NotApproved")
                      : obj.stages.every((stage) => stage.status === "Approved")
                        ? obj.stages.length
                        : obj.stages.findIndex((stage) => stage.status === "InProcess") !== -1
                          ? obj.stages.findIndex((stage) => stage.status === "InProcess")
                          : obj.stages.findIndex((stage) => stage.status === "NotStarted") !== -1
                            ? obj.stages.findIndex((stage) => stage.status === "NotStarted")
                            : obj.stages.length - 1;

                  const activeStepStatus =
                    obj?.stages.find(step => step.status === "NotApproved")?.status ||
                    obj?.stages.find(step => step.status === "InProcess")?.status ||
                    obj?.stages.find(step => step.status === "NotStarted")?.status;

                  const activeColor = activeStepStatus === "NotApproved"
                    ? "#E44545"
                    : activeStepStatus === "InProcess"
                      ? "#ECB800"
                      : activeStepStatus === "NotStarted"
                        ? "#8B8D91"
                        : "#339900";

                  const activeTitleColor = activeStepStatus === "NotApproved"
                    ? "#E44545"
                    : activeStepStatus === "InProcess"
                      ? "#ECB800"
                      : activeStepStatus === "NotStarted"
                        ? "#8B8D91"
                        : "#339900";

                  const activeBarColor = activeStepStatus === "NotApproved"
                    ? "#E44545"
                    : activeStepStatus === "InProcess"
                      ? "#ECB800"
                      : activeStepStatus === "NotStarted"
                        ? "#8B8D91"
                        : "#339900";
                  return (
                    <div className="tracking_block mb-4" key={obj?.Id}>
                      <div className="first_track_block">
                        <p>
                          <span>{obj?.patientId?.name?.text} </span>| {age} | {obj?.patientId?.address?.state} - {obj?.title}
                        </p>
                        <div>
                          <Stepper
                            activeColor={activeColor}
                            defaultColor="#8B8D91"
                            completeColor="#339900"
                            activeTitleColor={activeTitleColor}
                            completeTitleColor="#339900"
                            activeBarColor={activeBarColor}
                            completeBarColor="#339900"
                            steps={obj?.stages.map((step) => ({
                              title: (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <h6>{step?.name}</h6>
                                  {step?.status === "InProcess" && (
                                    <button
                                      style={{
                                        marginLeft: '10px',
                                        backgroundColor: '#335FFC',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '4px 6px',
                                        fontWeight:"600",
                                        cursor: 'pointer'
                                      }}
                                    >
                                      Current Stage
                                    </button>
                                  )}
                                </div>
                              )
                            }))}
                            activeStep={activeStepIndex}
                          />
                        </div>
                      </div>
                      <div className="describe d-flex align-items-center justify-content-between">
                        <p>Latest Activity : {obj?.latestUpdate}</p>
                        <button className="details" onClick={()=> navigate("/app/application-detail", {state : {applicationData : {...obj, patientData : obj?.patientData}}})}>View Details</button>
                      </div>
                    </div>
                  );
                }) : null}
              </div>
            </div>
          </div>
        </div>
        {!openTaskForm ? (<div className="pending_action">
          <div className="pending_action_header">
            <h2 className="activity_name">Pending Actions</h2>
          </div>
          <div className="p-4">
            <div className="action_type">
            {pendingTasks?.length > 0 ? pendingTasks?.map((task, index)=>(
                    <>
                      <div className={task?.status === "To Do" ? "action_blk" : "action_blk"}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <i className="fa fa-info-circle"></i>
                          <p className="due_block">Due in {Math.max(0, moment(task?.dueDate, "MM-DD-YYYY").diff(moment(), "days")) + " Days"}</p>
                          <div className="divider-block"></div>
                          <div>
                            <p className="desc_action_title" style={{color : "#335FFC"}}>
                              {task.title}
                            </p>
                            <p className="desc_action">
                              {task.assignTo ?  `Task ${task?.taskAction} Assigned to ${task.assignTo?.firstName + " " + task.assignTo?.lastName} for patient ${task?.patientId?.name?.text}` : `Task ${task?.taskAction} Assigned to patient ${task?.patientId?.name?.text}`}
                            </p>
                          </div>
                        </div>
                        {task?.taskAction == "Upload Document" && <>
                            <>
                            <button
                              className="schedule_btn"
                              onClick={() => triggerFileInputDoc(task?.applicationId, task?._id, index)}
                            >
                              Upload
                            </button>
                            <input
                              type="file"
                              id={`fileInputDoc-${task?.applicationId}-${task?._id}-${index}`}
                              style={{ display: "none" }}
                              onChange={(e) =>
                                handleFileSelect(e, task?._id, task?.documentId, task, task?.applicationId)
                              }
                            />
                          </>
                        </>}
                        {task?.taskAction !== "Upload Document" &&
                          <button className="schedule_btn"
                          onClick={() => {setShowPdfViewModal(true); setPdfUrl(task?.signedUrl); setFormData(task);}}
                        >
                          {task?.taskAction === "Sign Form" ? "Sign" :
                            task?.taskAction === "Verify Form" ? "Verify" :
                            task?.taskAction === "Update Form" ? "Update" :
                            "View"
                          }
                        </button>
                        }
                      </div>
                    </div>
                  </>
                )) : <h4 className="d-flex justify-content-center">No Data</h4>}
            </div>
          </div>
        </div>) :
          (<Tasks setOpenTaskForm={() => setOpenTaskForm(false)} />)}
      </div>
    </Fragment>
  );
};

export default PatientActivity;
